import {
  RichTextEditorComment,
  RichTextEditorCommentThread,
} from 'app/shared/components/RichTextEditor/models';
import {
  RichTextEditorCommentPayload,
  RichTextEditorCommentThreadPayload,
  RichTextEditorCommentThreadIdPayload,
  AddCommentToNarrativePayload,
} from 'app/shared/components/RichTextEditor/requests';
import { post } from 'app/shared/utils/fetchr';

export const addRichTextEditorComment = (
  payload: RichTextEditorCommentPayload,
): Promise<RichTextEditorComment> =>
  post('/v1/inline-comments/comment/add', payload);

export const updateRichTextEditorComment = (
  payload: RichTextEditorCommentPayload,
): Promise<void> => post('/v1/inline-comments/comment/update', payload);

export const deleteRichTextEditorComment = (
  payload: RichTextEditorCommentPayload,
): Promise<void> => post('/v1/inline-comments/comment/delete', payload);

export const addRichTextEditorCommentThread = (
  payload: RichTextEditorCommentThreadPayload,
): Promise<RichTextEditorCommentThread> =>
  post('/v1/inline-comments/thread/add', payload);

export const getRichTextEditorCommentThread = (
  payload: RichTextEditorCommentThreadIdPayload,
): Promise<RichTextEditorCommentThread> =>
  post(`/v1/inline-comments/thread/get`, payload);

export const resolveRichTextEditorCommentThread = (
  payload: RichTextEditorCommentThreadIdPayload,
): Promise<RichTextEditorCommentThread> =>
  post(`/v1/inline-comments/thread/resolve`, payload);

export const reopenRichTextEditorCommentThread = (
  payload: RichTextEditorCommentThreadIdPayload,
): Promise<void> => post(`/v1/inline-comments/thread/reopen`, payload);

export const deleteRichTextEditorCommentThread = (
  payload: RichTextEditorCommentThreadIdPayload,
): Promise<void> => post(`/v1/inline-comments/thread/delete`, payload);

export const addCommentToNarrative = (
  payload: AddCommentToNarrativePayload,
): Promise<void> =>
  post(`/v1/inline-comments/add-comment-to-narrative`, payload);
